import type { TodayPriority } from '../api/client'

// emptyDayLine is what Your day says when nothing is booked today. The
// overdue-client advice only when Today is suggesting one (a new account has
// no clients to contact: QA 2026-10-14); while she is still setting up, the
// checklist above says what to do next; otherwise her booking page is on and
// sharing it is the next step.
export function emptyDayLine(priorities: Pick<TodayPriority, 'type'>[], settingUp: boolean): string {
  if (priorities.some((p) => p.type === 'rebooking')) {
    return 'Your calendar is empty today. Contacting an overdue client is the fastest way to fill it.'
  }
  if (settingUp) return 'Your calendar is empty today.'
  return 'Your calendar is empty today. Sharing your booking page is a good way to fill it.'
}
